import createSagaMiddleware from "@redux-saga/core";
import { configureStore, ConfigureStoreOptions } from "@reduxjs/toolkit";

import { rootReducer } from "./reducer";
import { rootSagas } from "./sagas";

const sagaMiddleware = createSagaMiddleware();

export function createStore(
  options: Partial<ConfigureStoreOptions> = {}
) {
  return configureStore({
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false })
        .concat(sagaMiddleware),
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== "production",
    ...options,
  });
}

export const store = createStore();

sagaMiddleware.run(rootSagas);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type RootAction = ReturnType<AppDispatch>;
